<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import { required } from "vuelidate/lib/validators";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import CheckModal from "@/components/CheckModal"
import ItemAPI from "@/services/items/itemsAPI";
import evaluacionImpactoAPI from "../../../services/standards/evaluacionImpacto/evaluacionImpactoAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "2.11.1 Gestión del cambio",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {

    return {
      title: "2.11.1 Gestión del cambio",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "2.11.1 Gestión del cambio",
        },
        {
          text: "Ver",
          active: true,
        },
      ],

      lista: [],
      loading: true,

      itemData: null,

      item: null,

      itemData: null,

      evaluacionImpacto: {
        type_change: null,
        description: null,
        file: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      submitted: false,

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

    };
  },

  validations: {
    evaluacionImpacto: {
      type_change: {
        required,
      },
      description: {
        required,
      },

    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(22)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    goPage(page) {
      window.location.href = page
    },

    fetch() {
      this.$refs.paginator.query();
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 22)
        .then(response => {
          this.item = response || null
        })
        .catch(error => {
          console.log(error)
        })
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions
        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    getShow() {
      evaluacionImpactoAPI
        .getShow(this.$route.params.id)
        .then((response) => {
          this.loading = false
          this.evaluacionImpacto = {
            type_change: response.data.type_change,
            file: response.data.file,
            description: response.data.description,
            companies_id: response.data.companies_id,
          };
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

  },

  mounted() {
    this.getItems();
    this.getItemData();
    this.getShow();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                </div>
                <div class="col-6 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
              <hr />

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">

                  <b-form-group label-for="employee" class="col-md-6 px-2 mb-3" label="Tipo de cambio">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="evaluacionImpacto.type_change" disabled
                      :class="{ 'is-invalid': $v.evaluacionImpacto.type_change.$error && submitted }">
                      <b-form-select-option value="Infraestructura">
                        Infraestructura
                      </b-form-select-option>
                      <b-form-select-option value="Legislación">
                        Legislación
                      </b-form-select-option>
                      <b-form-select-option value="Procesos o proyectos">
                        Procesos o proyectos
                      </b-form-select-option>
                      <b-form-select-option value="Puestos de trabajo">
                        Puestos de trabajo
                      </b-form-select-option>
                      <b-form-select-option value="Tecnología">
                        Tecnología
                      </b-form-select-option>
                    </select>
                    <div v-if="submitted && $v.evaluacionImpacto.type_change.$error">
                      <small v-if="!$v.evaluacionImpacto.type_change.required" class="text-danger">
                        <b>El tipo de cambio es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2 mb-3 text-center" label="Descargar evidencia" label-for="file">

                    <div class="d-flex justify-content-center">
                      <button class="" led="!allowAccess()"
                        style=" background-color: transparent !important; border: none;" type="button"
                        @click="gotoDigitalOcean(`${evaluacionImpacto.file}`)"> <i class="mdi mdi-cloud-download"></i>
                      </button>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Descripción del cambio a realizar"
                    label-for="trainingDate">
                    <b-form-textarea disabled id="trainingDate" v-model="evaluacionImpacto.description" maxlength="400"
                      :class="{ 'is-invalid': $v.evaluacionImpacto.description.$error && submitted }">
                      >
                    </b-form-textarea>
                    <div v-if="submitted && $v.evaluacionImpacto.description.$error">
                      <small v-if="!$v.evaluacionImpacto.description.required" class="text-danger">
                        <b>La descripción es requerida</b>
                      </small>
                    </div>
                  </b-form-group>

                </div>

              </form>
            </div>
          </div>

        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>